import React from "react";
import "./App.css";

// Responsive hook for window width
function useWindowWidth() {
  const [width, setWidth] = React.useState(
    typeof window !== "undefined" ? window.innerWidth : 1200,
  );

  React.useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return width;
}

// Events Photo Carousel Component - RESPONSIVE
function EventsPhotoCarousel() {
  const [currentPhoto, setCurrentPhoto] = React.useState(0);
  const width = useWindowWidth();
  const isMobile = width < 768;
  const isTablet = width >= 768 && width < 1024;

  const photos = [
    {
      url: "https://firebasestorage.googleapis.com/v0/b/anna-copperfield.firebasestorage.app/o/p1.jpeg?alt=media&token=5109ae1f-2cd1-4e2c-bbdb-ea5b8e68c8b1",
      caption: "",
    },
    {
      url: "https://firebasestorage.googleapis.com/v0/b/anna-copperfield.firebasestorage.app/o/p2.jpeg?alt=media&token=8b24ac8d-fb6e-433b-abe8-0e4f045ea412",
      caption: "",
    },
    {
      url: "https://firebasestorage.googleapis.com/v0/b/anna-copperfield.firebasestorage.app/o/p3.jpeg?alt=media&token=fa78f859-bd4a-483a-b80f-bd2998132314",
      caption: "",
    },
    {
      url: "https://firebasestorage.googleapis.com/v0/b/anna-copperfield.firebasestorage.app/o/p4.jpeg?alt=media&token=ad40d4d2-2c14-4b19-bebf-9e39ef617fc3",
      caption: "",
    },
    {
      url: "https://firebasestorage.googleapis.com/v0/b/anna-copperfield.firebasestorage.app/o/p6.JPG?alt=media&token=3460d8b8-ac00-4b58-b704-d2c82bac3bbb",
      caption: "",
    },
    {
      url: "https://firebasestorage.googleapis.com/v0/b/anna-copperfield.firebasestorage.app/o/p8-edit.jpg?alt=media&token=9afa6431-c194-46a9-8fb0-15acf411969d",
      caption: "",
    },
    {
      url: "https://firebasestorage.googleapis.com/v0/b/anna-copperfield.firebasestorage.app/o/p10.jpeg?alt=media&token=9ae47108-4efd-49f6-948c-9b985b18efe0",
      caption: "",
    },
    {
      url: "https://firebasestorage.googleapis.com/v0/b/anna-copperfield.firebasestorage.app/o/p11.JPG?alt=media&token=3c5cd0a7-2367-404b-94ea-f3423f745f05",
      caption: "",
    },
    {
      url: "https://firebasestorage.googleapis.com/v0/b/anna-copperfield.firebasestorage.app/o/p13.jpg?alt=media&token=1fb851b6-9863-481f-b990-a91f16f94f03",
      caption: "",
    },
    {
      url: "https://firebasestorage.googleapis.com/v0/b/anna-copperfield.firebasestorage.app/o/p15.jpg?alt=media&token=e6c63991-51c8-43f3-b4e6-9e1fe0ae8fb5",
      caption: "",
    },
    {
      url: "https://firebasestorage.googleapis.com/v0/b/anna-copperfield.firebasestorage.app/o/p16.jpg?alt=media&token=51c3a13d-cb83-4a80-86cf-be263af97eaa",
      caption: "",
    },
  ];

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPhoto((prev) => (prev + 1) % photos.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [photos.length]);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: isMobile ? "400px" : isTablet ? "500px" : "650px",
        overflow: "hidden",
        borderRadius: isMobile ? "12px" : "16px",
        marginTop: isMobile ? "2rem" : "3rem",
        background: "#000000",
        boxShadow: `
                    0 0 40px rgba(197, 122, 92, 0.4),
                    0 0 80px rgba(197, 122, 92, 0.3),
                    0 0 120px rgba(227, 139, 111, 0.2),
                    0 10px 60px rgba(197, 122, 92, 0.25)
                `,
      }}
    >
      {/* Photos */}
      {photos.map((photo, index) => (
        <div
          key={index}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            opacity: currentPhoto === index ? 1 : 0,
            transition: "opacity 1s ease-in-out",
            pointerEvents: currentPhoto === index ? "auto" : "none",
          }}
        >
          <img
            src={photo.url}
            alt={photo.caption}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />

          {/* Caption Overlay */}
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              padding: isMobile ? "1.5rem" : isTablet ? "2rem" : "2.5rem",
              background:
                "linear-gradient(to top, rgba(42, 42, 42, 0.9) 0%, transparent 100%)",
            }}
          >
            <p
              style={{
                fontSize: isMobile ? "1rem" : isTablet ? "1.25rem" : "1.5rem",
                color: "#FFFFFF",
                fontFamily: "Georgia, serif",
                fontStyle: "italic",
                letterSpacing: "0.02em",
                textAlign: "center",
              }}
            >
              {photo.caption}
            </p>
          </div>
        </div>
      ))}

      {/* Dots Indicator */}
      <div
        style={{
          position: "absolute",
          bottom: isMobile ? "1rem" : "2rem",
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: isMobile ? "0.5rem" : "0.75rem",
          zIndex: 10,
        }}
      >
        {photos.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentPhoto(index)}
            style={{
              width: isMobile ? "8px" : "12px",
              height: isMobile ? "8px" : "12px",
              borderRadius: "50%",
              border: "none",
              background:
                currentPhoto === index ? "#FFFFFF" : "rgba(255, 255, 255, 0.5)",
              cursor: "pointer",
              transition: "all 0.3s ease",
              padding: 0,
              boxShadow:
                currentPhoto === index
                  ? "0 0 12px rgba(255, 255, 255, 0.9)"
                  : "none",
            }}
            aria-label={`Go to photo ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}

function App() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const width = useWindowWidth();
  const isMobile = width < 957;
  const isTablet = width >= 9957 && width < 1080;
  const isDesktop = width >= 1080;

  // Helper at the top of your App component
  const [isLandscape, setIsLandscape] = React.useState(
    typeof window !== "undefined"
      ? window.innerHeight < window.innerWidth
      : false,
  );

  React.useEffect(() => {
    const handleOrientationChange = () => {
      setIsLandscape(window.innerHeight < window.innerWidth);
    };

    window.addEventListener("resize", handleOrientationChange);
    window.addEventListener("orientationchange", handleOrientationChange);

    return () => {
      window.removeEventListener("resize", handleOrientationChange);
      window.removeEventListener("orientationchange", handleOrientationChange);
    };
  }, []);

  return (
    <div
      className="App"
      style={{
        margin: 0,
        padding: 0,
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        background: "#F5F1E8",
        color: "#3a3a3a",
      }}
    >
      {/* Burger Menu Navigation - Always Visible - RESPONSIVE */}
      <nav
        style={{
          position: "fixed",
          top: isMobile ? "1rem" : "2rem",
          right: isMobile ? "1rem" : "2rem",
          zIndex: 1000,
        }}
      >
        {/* Burger Button Pill */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          style={{
            padding: isMobile ? "0.6rem 1.2rem" : "0.75rem 1.5rem",
            borderRadius: "50px",
            background: "rgba(0, 0, 0, 0.3)",
            backdropFilter: "blur(30px) saturate(180%)",
            WebkitBackdropFilter: "blur(30px) saturate(180%)",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
            border: "1px solid rgba(255, 255, 255, 0.1)",
            cursor: "pointer",
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.3s ease",
          }}
          aria-label="Toggle menu"
        >
          {/* Hamburger Icon Lines */}
          <div
            style={{
              width: isMobile ? "20px" : "24px",
              height: "2px",
              background: "rgba(255, 255, 255, 0.8)",
              transition: "all 0.3s ease",
              transform: isMenuOpen ? "rotate(45deg) translateY(7px)" : "none",
            }}
          ></div>
          <div
            style={{
              width: isMobile ? "20px" : "24px",
              height: "2px",
              background: "rgba(255, 255, 255, 0.8)",
              transition: "all 0.3s ease",
              opacity: isMenuOpen ? 0 : 1,
            }}
          ></div>
          <div
            style={{
              width: isMobile ? "20px" : "24px",
              height: "2px",
              background: "rgba(255, 255, 255, 0.8)",
              transition: "all 0.3s ease",
              transform: isMenuOpen
                ? "rotate(-45deg) translateY(-7px)"
                : "none",
            }}
          ></div>
        </button>

        {/* Dropdown Menu */}
        {isMenuOpen && (
          <div
            style={{
              position: "absolute",
              top: isMobile ? "3.5rem" : "4.5rem",
              right: 0,
              minWidth: isMobile ? "180px" : "200px",
              borderRadius: "16px",
              background: "rgba(0, 0, 0, 0.3)",
              backdropFilter: "blur(30px) saturate(180%)",
              WebkitBackdropFilter: "blur(30px) saturate(180%)",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              padding: isMobile ? "0.75rem" : "1rem",
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
              animation: "fadeIn 0.3s ease",
            }}
          >
            <a
              href="#home"
              onClick={() => setIsMenuOpen(false)}
              style={{
                textDecoration: "none",
                color: "rgba(255, 255, 255, 0.8)",
                fontSize: isMobile ? "0.8rem" : "0.875rem",
                fontWeight: "500",
                letterSpacing: "0.02em",
                transition: "all 0.2s ease",
                padding: isMobile ? "0.6rem 0.8rem" : "0.75rem 1rem",
                borderRadius: "8px",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "rgba(255, 255, 255, 1)";
                e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "rgba(255, 255, 255, 0.8)";
                e.currentTarget.style.background = "transparent";
              }}
            >
              Home
            </a>
            <a
              href="#about"
              onClick={() => setIsMenuOpen(false)}
              style={{
                textDecoration: "none",
                color: "rgba(255, 255, 255, 0.8)",
                fontSize: isMobile ? "0.8rem" : "0.875rem",
                fontWeight: "500",
                letterSpacing: "0.02em",
                transition: "all 0.2s ease",
                padding: isMobile ? "0.6rem 0.8rem" : "0.75rem 1rem",
                borderRadius: "8px",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "rgba(255, 255, 255, 1)";
                e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "rgba(255, 255, 255, 0.8)";
                e.currentTarget.style.background = "transparent";
              }}
            >
              About
            </a>
            <a
              href="#offerings"
              onClick={() => setIsMenuOpen(false)}
              style={{
                textDecoration: "none",
                color: "rgba(255, 255, 255, 0.8)",
                fontSize: isMobile ? "0.8rem" : "0.875rem",
                fontWeight: "500",
                letterSpacing: "0.02em",
                transition: "all 0.2s ease",
                padding: isMobile ? "0.6rem 0.8rem" : "0.75rem 1rem",
                borderRadius: "8px",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "rgba(255, 255, 255, 1)";
                e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "rgba(255, 255, 255, 0.8)";
                e.currentTarget.style.background = "transparent";
              }}
            >
              Offerings
            </a>
            <a
              href="#testimonials"
              onClick={() => setIsMenuOpen(false)}
              style={{
                textDecoration: "none",
                color: "rgba(255, 255, 255, 0.8)",
                fontSize: isMobile ? "0.8rem" : "0.875rem",
                fontWeight: "500",
                letterSpacing: "0.02em",
                transition: "all 0.2s ease",
                padding: isMobile ? "0.6rem 0.8rem" : "0.75rem 1rem",
                borderRadius: "8px",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "rgba(255, 255, 255, 1)";
                e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "rgba(255, 255, 255, 0.8)";
                e.currentTarget.style.background = "transparent";
              }}
            >
              Testimonials
            </a>
            <a
              href="#contact"
              onClick={() => setIsMenuOpen(false)}
              style={{
                textDecoration: "none",
                color: "rgba(255, 255, 255, 0.8)",
                fontSize: isMobile ? "0.8rem" : "0.875rem",
                fontWeight: "500",
                letterSpacing: "0.02em",
                transition: "all 0.2s ease",
                padding: isMobile ? "0.6rem 0.8rem" : "0.75rem 1rem",
                borderRadius: "8px",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "rgba(255, 255, 255, 1)";
                e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "rgba(255, 255, 255, 0.8)";
                e.currentTarget.style.background = "transparent";
              }}
            >
              Contact
            </a>
          </div>
        )}
      </nav>

      {/* Hero Section - RESPONSIVE with Different Images per Screen Size */}
      <section
        id="home"
        style={{
          position: "relative",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          backgroundImage: isDesktop
            ? "url(https://firebasestorage.googleapis.com/v0/b/anna-copperfield.firebasestorage.app/o/heroImg-cr2-e1.jpeg?alt=media&token=3acd5384-7c83-4306-8443-2b159eb9232f)" // Desktop landscape
            : isMobile && isLandscape
              ? "url(https://firebasestorage.googleapis.com/v0/b/anna-copperfield.firebasestorage.app/o/heroImg-cr4-e.jpeg?alt=media&token=0564e062-d3ec-460c-b757-f4bce0e0be9b)" // Mobile landscape (NEW)
              : "url(https://firebasestorage.googleapis.com/v0/b/anna-copperfield.firebasestorage.app/o/heroImg-cr-e.jpeg?alt=media&token=2916f436-e4c5-41da-a119-5f77ffd6021d)", // Mobile/Tablet portrait
          backgroundSize: "cover",
          backgroundPosition: isMobile ? "center 30%" : "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "linear-gradient(to bottom, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.35))",
            zIndex: 1,
          }}
        ></div>

        <div
          style={{
            position: "relative",
            zIndex: 2,
            textAlign: "center",
            maxWidth: isMobile ? "100%" : "900px",
            padding: isMobile ? "0 1.5rem" : "0 2rem",
          }}
        >
          <h1
            style={{
              fontSize: isMobile ? "4rem" : isTablet ? "6rem" : "8rem",
              fontWeight: "300",
              fontFamily: 'Georgia, "Times New Roman", serif',
              fontStyle: "italic",
              lineHeight: "1",
              marginBottom: isMobile ? "1rem" : "1.5rem",
              color: "#fff",
              letterSpacing: "0.02em",
              textShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
            }}
          >
            Anna
          </h1>

          <p
            style={{
              fontSize: isMobile ? "0.9rem" : isTablet ? "1.1rem" : "1.3rem",
              fontWeight: "300",
              color: "rgba(255, 255, 255, 0.95)",
              letterSpacing: isMobile ? "0.05em" : "0.15em",
              textTransform: "lowercase",
              textShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
              lineHeight: "1.6",
            }}
          >
            transforming how people and brands grow,
            <br />
            through energy, clarity, and connection.
          </p>
        </div>

        <div
          style={{
            position: "absolute",
            bottom: isMobile ? "2rem" : "3rem",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "0.5rem",
          }}
        >
          <div
            style={{
              fontSize: isMobile ? "0.65rem" : "0.7rem",
              color: "rgba(255, 255, 255, 0.7)",
              letterSpacing: "0.15em",
              textTransform: "uppercase",
            }}
          >
            Scroll
          </div>
          <div
            style={{
              width: "1px",
              height: isMobile ? "30px" : "40px",
              background:
                "linear-gradient(to bottom, rgba(255, 255, 255, 0.5), transparent)",
            }}
          ></div>
        </div>
      </section>

      {/* About Anna Section - RESPONSIVE (Landscape 7071 × 4716) */}
      <section
        id="about"
        style={{
          minHeight: "100vh",
          background: "#0a0a0a",
          display: isMobile ? "block" : "grid",
          gridTemplateColumns: isMobile ? "1fr" : isTablet ? "1fr" : "50% 50%",
        }}
      >
        {/* Left Side - Clean Cream Elegance - RESPONSIVE */}
        <div
          style={{
            background: "#FDFBF7",
            padding: isMobile
              ? "4rem 2rem"
              : isTablet
                ? "5rem 3rem"
                : "6rem 5rem",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            position: "relative",
          }}
        >
          {/* Content Sections */}
          <div
            style={{ maxWidth: isMobile ? "100%" : "540px", margin: "0 auto" }}
          >
            {/* Opening Statement */}
            <div style={{ marginBottom: isMobile ? "2.5rem" : "3.5rem" }}>
              <h3
                style={{
                  fontSize: isMobile
                    ? "1.25rem"
                    : isTablet
                      ? "1.5rem"
                      : "1.75rem",
                  fontWeight: "400",
                  color: "#C57A5C",
                  marginBottom: "1rem",
                  fontFamily: '"Calluna", "Freight Text Pro", serif',
                  letterSpacing: "0.05em",
                  fontStyle: "italic",
                }}
              >
                From Resistance to Flow
              </h3>
              <p
                style={{
                  fontSize: isMobile
                    ? "0.95rem"
                    : isTablet
                      ? "1rem"
                      : "1.0625rem",
                  lineHeight: "1.9",
                  color: "#5A5A5A",
                  fontWeight: "400",
                  fontFamily:
                    '"Adobe Caslon Pro", "Big Caslon", Georgia, serif',
                  letterSpacing: "0.02em",
                }}
              >
                I help founders, leaders, creatives and empowered people move
                into flow. Whether it's refining a business model, identifying
                new revenue streams, raising capital or connecting with aligned
                partners. My work focuses on creating momentum, where things
                have slowed.
              </p>
            </div>

            {/* Background */}
            <div style={{ marginBottom: isMobile ? "2.5rem" : "3.5rem" }}>
              <h3
                style={{
                  fontSize: isMobile
                    ? "1.25rem"
                    : isTablet
                      ? "1.5rem"
                      : "1.75rem",
                  fontWeight: "400",
                  color: "#C57A5C",
                  marginBottom: "1rem",
                  fontFamily: '"Calluna", "Freight Text Pro", serif',
                  letterSpacing: "0.05em",
                  fontStyle: "italic",
                }}
              >
                My Background
              </h3>
              <p
                style={{
                  fontSize: isMobile
                    ? "0.95rem"
                    : isTablet
                      ? "1rem"
                      : "1.0625rem",
                  lineHeight: "1.9",
                  color: "#5A5A5A",
                  fontWeight: "400",
                  fontFamily:
                    '"Adobe Caslon Pro", "Big Caslon", Georgia, serif',
                  letterSpacing: "0.02em",
                }}
              >
                Raised in the Midwest, I hold a degree in Communication Sciences
                and have built a career rooted in connection. I've worked across
                multiple industries, from medical sales to wealth management,
                where I helped founders prepare for and navigate liquidity
                events.
              </p>
            </div>

            {/* Journey */}
            <div style={{ marginBottom: isMobile ? "2.5rem" : "3.5rem" }}>
              <h3
                style={{
                  fontSize: isMobile
                    ? "1.25rem"
                    : isTablet
                      ? "1.5rem"
                      : "1.75rem",
                  fontWeight: "400",
                  color: "#C57A5C",
                  marginBottom: "1rem",
                  fontFamily: '"Calluna", "Freight Text Pro", serif',
                  letterSpacing: "0.05em",
                  fontStyle: "italic",
                }}
              >
                The Journey
              </h3>
              <p
                style={{
                  fontSize: isMobile
                    ? "0.95rem"
                    : isTablet
                      ? "1rem"
                      : "1.0625rem",
                  lineHeight: "1.9",
                  color: "#5A5A5A",
                  fontWeight: "400",
                  fontFamily:
                    '"Adobe Caslon Pro", "Big Caslon", Georgia, serif',
                  letterSpacing: "0.02em",
                }}
              >
                Earlier in my journey, I founded a women's organization centered
                on connection over competition. Alongside my professional path,
                I've spent the past five years immersed in the study of
                emotional intelligence, awareness, and spirituality.
              </p>
            </div>

            {/* Today */}
            <div style={{ marginBottom: isMobile ? "2.5rem" : "3.5rem" }}>
              <h3
                style={{
                  fontSize: isMobile
                    ? "1.25rem"
                    : isTablet
                      ? "1.5rem"
                      : "1.75rem",
                  fontWeight: "400",
                  color: "#C57A5C",
                  marginBottom: "1rem",
                  fontFamily: '"Calluna", "Freight Text Pro", serif',
                  letterSpacing: "0.05em",
                  fontStyle: "italic",
                }}
              >
                Today
              </h3>
              <p
                style={{
                  fontSize: isMobile
                    ? "0.95rem"
                    : isTablet
                      ? "1rem"
                      : "1.0625rem",
                  lineHeight: "1.9",
                  color: "#5A5A5A",
                  fontWeight: "400",
                  fontFamily:
                    '"Adobe Caslon Pro", "Big Caslon", Georgia, serif',
                  letterSpacing: "0.02em",
                }}
              >
                I bring all of that experience, from boardrooms to spiritual
                study, from motherhood to market strategy, into one integrated
                practice. Every engagement is designed to create momentum, the
                kind that's both measurable and deeply felt.
              </p>
            </div>

            {/* Main Headline */}
            <p
              style={{
                fontSize: isMobile ? "1.75rem" : isTablet ? "2.5rem" : "3rem",
                fontWeight: "200",
                color: "#2A2A2A",
                lineHeight: "1.2",
                marginBottom: "1.5rem",
                fontFamily:
                  '"Orpheus Pro", "Cormorant", "Playfair Display", serif',
                letterSpacing: "0.02em",
                fontStyle: "italic",
              }}
            >
              Let's write the next chapter together
            </p>
          </div>
        </div>

        {/* Right Side - Clean Image - RESPONSIVE */}
        <div
          style={{
            position: "relative",
            backgroundImage: isMobile
              ? "url(https://firebasestorage.googleapis.com/v0/b/anna-copperfield.firebasestorage.app/o/about-img-cr2-e.jpeg?alt=media&token=50749c1e-7714-43aa-bd45-fbec441bb3a1)" // Mobile portrait/square
              : "url(https://firebasestorage.googleapis.com/v0/b/anna-copperfield.firebasestorage.app/o/about-img-cr-e.jpeg?alt=media&token=b45f2b9f-8b43-4b9a-90b5-54c6f5e7b54c)", // Desktop landscape
            backgroundSize: "cover",
            backgroundPosition: isMobile ? "center" : "center",
            minHeight: "830px",
          }}
        >
          {/* Minimal overlay */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background:
                "linear-gradient(to bottom, rgba(253, 251, 247, 0.1) 0%, rgba(42, 42, 42, 0.6) 100%)",
            }}
          ></div>

          {/* Bottom Text Overlay */}
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              padding: isMobile
                ? "3rem 2rem"
                : isTablet
                  ? "4rem 3rem"
                  : "5rem 4rem 5.5rem",
              background:
                "linear-gradient(to top, rgba(42, 42, 42, 0.95) 0%, transparent 100%)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <p
              style={{
                fontSize: isMobile ? "2rem" : isTablet ? "2.5rem" : "3rem",
                lineHeight: "1.4",
                color: "#FDFBF7",
                fontWeight: "300",
                maxWidth: isMobile ? "100%" : "540px",
                fontFamily: '"Orpheus Pro", "Cormorant", serif',
                fontStyle: "italic",
                letterSpacing: "0.015em",
              }}
            >
              Whether it's{" "}
              <span style={{ color: "#C57A5C", fontWeight: "400" }}>
                a big idea
              </span>{" "}
              or{" "}
              <span style={{ color: "#E38B6F", fontWeight: "400" }}>
                a small spark
              </span>
              , I'd love to hear what's on your mind
            </p>
          </div>
        </div>
      </section>

      {/* Offerings Section - RESPONSIVE */}
      <section
        id="offerings"
        style={{
          minHeight: "100vh",
          background: "#0a0a0a",
          display: isMobile ? "block" : "grid",
          gridTemplateColumns: isMobile ? "1fr" : isTablet ? "1fr" : "40% 60%",
        }}
      >
        {/* Left Side - RESPONSIVE */}
        <div
          style={{
            background: "#FFFFFF",
            padding: isMobile
              ? "4rem 2rem"
              : isTablet
                ? "5rem 3rem"
                : "6rem 5rem",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Bottom Left Corner Gradient */}
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: isMobile ? "200px" : "300px",
              height: isMobile ? "200px" : "300px",
              background:
                "radial-gradient(circle at top right, rgba(227, 139, 111, 0.03) 0%, rgba(232, 180, 174, 0.015) 35%, transparent 65%)",
              pointerEvents: "none",
              zIndex: 1,
            }}
          ></div>

          {/* Content with higher z-index */}
          <div style={{ position: "relative", zIndex: 2 }}>
            {/* Small Label */}
            <p
              style={{
                fontSize: "0.625rem",
                letterSpacing: "0.5em",
                textTransform: "uppercase",
                color: "#2A2A2A",
                marginBottom: isMobile ? "2rem" : "3rem",
                fontWeight: "600",
                fontFamily:
                  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
              }}
            >
              Offerings
            </p>

            {/* Main Headline */}
            <p
              style={{
                fontSize: isMobile ? "1.5rem" : isTablet ? "1.75rem" : "2rem",
                fontWeight: "100",
                color: "#C57A5C",
                lineHeight: "1.3",
                marginBottom: isMobile ? "2rem" : "2.5rem",
                fontFamily: 'Georgia, "Times New Roman", serif',
                letterSpacing: "0.01em",
                fontStyle: "italic",
              }}
            >
              Each offering is designed to bring clarity, alignment and flow.
            </p>

            {/* Body Content */}
            <div
              style={{
                maxWidth: isMobile ? "100%" : "500px",
                margin: "0 auto",
              }}
            >
              <p
                style={{
                  fontSize: isMobile ? "1rem" : "1.125rem",
                  lineHeight: "1.9",
                  color: "#2A2A2A",
                  fontWeight: "300",
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  letterSpacing: "0.01em",
                  marginBottom: "2rem",
                }}
              >
                Turning insight into tangible movement. Whether you are refining
                your next chapter, expanding a business, or bridging energy with
                strategy, this is where intention meets execution.
              </p>

              <p
                style={{
                  fontSize: isMobile ? "1rem" : "1.125rem",
                  lineHeight: "1.9",
                  color: "#2A2A2A",
                  fontWeight: "300",
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  letterSpacing: "0.01em",
                  marginBottom: "2rem",
                }}
              >
                Every session is designed to help you see what's possible.
              </p>

              <p
                style={{
                  fontSize: isMobile ? "1.1rem" : "1.25rem",
                  lineHeight: "1.8",
                  color: "#2A2A2A",
                  fontWeight: "400",
                  fontFamily: "Georgia, serif",
                  letterSpacing: "0.01em",
                }}
              >
                It's time to move what's ready to move.
              </p>

              {/* Carousel Component */}
              <EventsPhotoCarousel />
            </div>
          </div>
        </div>

        {/* Right Side - Acuity Scheduler - RESPONSIVE */}
        <div
          style={{
            background: "#FFFFFF",
            padding: isMobile
              ? "3rem 1.5rem"
              : isTablet
                ? "3.5rem 2.5rem"
                : "4rem 3rem",
            position: "relative",
            overflowY: "auto",
            overflow: "hidden",
            minHeight: isMobile ? "600px" : "auto",
          }}
        >
          {/* Gradients - Scaled for mobile */}
          <div
            style={{
              position: "absolute",
              bottom: 0,
              right: 0,
              width: isMobile ? "250px" : "400px",
              height: isMobile ? "250px" : "400px",
              background:
                "radial-gradient(circle at top right, rgba(227, 139, 111, 0.03) 0%, rgba(232, 180, 174, 0.015) 35%, transparent 65%)",
              pointerEvents: "none",
              zIndex: 1,
            }}
          ></div>

          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: isMobile ? "200px" : "350px",
              height: isMobile ? "200px" : "350px",
              background:
                "radial-gradient(circle at top right, rgba(227, 139, 111, 0.03) 0%, rgba(232, 180, 174, 0.015) 35%, transparent 65%)",
              pointerEvents: "none",
              zIndex: 1,
            }}
          ></div>

          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              width: isMobile ? "200px" : "350px",
              height: isMobile ? "200px" : "350px",
              background:
                "radial-gradient(circle at top right, rgba(227, 139, 111, 0.03) 0%, rgba(232, 180, 174, 0.015) 35%, transparent 65%)",
              pointerEvents: "none",
              zIndex: 1,
            }}
          ></div>

          <div
            style={{
              width: "100%",
              height: "100%",
              minHeight: isMobile ? "500px" : isTablet ? "600px" : "800px",
              position: "relative",
              zIndex: 2,
            }}
          >
              {/*/!* Mobile Scroll Hint - Only visible on mobile *!/*/}
              {/*{isMobile && (*/}
              {/*    <div*/}
              {/*        style={{*/}
              {/*            textAlign: "center",*/}
              {/*            marginBottom: "1.5rem",*/}
              {/*            padding: "1rem",*/}
              {/*            background: "rgba(197, 122, 92, 0.05)",*/}
              {/*            borderRadius: "12px",*/}
              {/*            border: "1px solid rgba(197, 122, 92, 0.15)",*/}
              {/*            position: "relative",*/}
              {/*            zIndex: 3,*/}
              {/*        }}*/}
              {/*    >*/}
              {/*        <p*/}
              {/*            style={{*/}
              {/*                fontSize: "0.875rem",*/}
              {/*                color: "#C57A5C",*/}
              {/*                fontWeight: "500",*/}
              {/*                margin: "0 0 0.5rem 0",*/}
              {/*                fontFamily:*/}
              {/*                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',*/}
              {/*                letterSpacing: "0.02em",*/}
              {/*            }}*/}
              {/*        >*/}
              {/*            ↓ Scroll within the booking area below ↓*/}
              {/*        </p>*/}
              {/*        <p*/}
              {/*            style={{*/}
              {/*                fontSize: "0.75rem",*/}
              {/*                color: "#5A5A5A",*/}
              {/*                margin: 0,*/}
              {/*                fontFamily:*/}
              {/*                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',*/}
              {/*            }}*/}
              {/*        >*/}
              {/*            Multiple offerings available*/}
              {/*        </p>*/}
              {/*    </div>*/}
              {/*)}*/}
            <iframe
              src="https://app.acuityscheduling.com/schedule.php?owner=37181319&ref=embedded_csp"
              title="Schedule Appointment"
              width="100%"
              height="100%"
              frameBorder="0"
              allow="payment"
              style={{
                border: "none",
                  minHeight: isMobile ? "900px" : isTablet ? "600px" : "800px", // Changed from 500px to 900px
              }}
            ></iframe>
            <script
              src="https://embed.acuityscheduling.com/js/embed.js"
              type="text/javascript"
            ></script>
          </div>
        </div>
      </section>

      {/* Testimonials Section - RESPONSIVE */}
      <section
        id="testimonials"
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #FFFDF9 0%, #FFF9F3 100%)",
          padding: isMobile
            ? "4rem 1.5rem"
            : isTablet
              ? "6rem 3rem"
              : "8rem 4rem",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Decorative gradient overlay */}
        <div
          style={{
            position: "absolute",
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            background:
              "radial-gradient(circle at 80% 20%, rgba(232, 180, 174, 0.2) 0%, transparent 50%)",
            pointerEvents: "none",
          }}
        ></div>

        <div
          style={{
            maxWidth: isMobile ? "100%" : "1400px",
            margin: "0 auto",
            position: "relative",
            zIndex: 1,
          }}
        >
          {/* Section Header - RESPONSIVE */}
          <div
            style={{
              textAlign: "center",
              marginBottom: isMobile ? "3rem" : "5rem",
            }}
          >
            {/* Small Label */}
            <p
              style={{
                fontSize: isMobile ? "0.55rem" : "0.625rem",
                letterSpacing: isMobile ? "0.4em" : "0.6em",
                textTransform: "uppercase",
                color: "#E38B6F",
                marginBottom: isMobile ? "1.5rem" : "2rem",
                fontWeight: "700",
                fontFamily:
                  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
              }}
            >
              What They're Saying
            </p>

            {/* Headline - RESPONSIVE */}
            <h2
              style={{
                fontSize: isMobile ? "2rem" : isTablet ? "3rem" : "4.5rem",
                fontWeight: "300",
                background:
                  "linear-gradient(135deg, #E38B6F 0%, #C57A5C 50%, #B8A593 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                lineHeight: "1.2",
                marginBottom: "1.5rem",
                fontFamily: 'Georgia, "Times New Roman", serif',
                letterSpacing: "0.02em",
                fontStyle: "italic",
              }}
            >
              Voices of Transformation
            </h2>

            {/* Decorative line */}
            <div
              style={{
                width: isMobile ? "80px" : "120px",
                height: isMobile ? "2px" : "3px",
                background: "linear-gradient(90deg, #E38B6F, #E8B4AE, #E38B6F)",
                margin: isMobile ? "1.5rem auto" : "2rem auto",
                boxShadow: "0 2px 12px rgba(227, 139, 111, 0.3)",
              }}
            ></div>

            {/* Subtext - RESPONSIVE */}
            <p
              style={{
                fontSize: isMobile ? "1rem" : isTablet ? "1.1rem" : "1.25rem",
                lineHeight: "1.8",
                color: "#3A3A3A",
                fontWeight: "300",
                fontFamily:
                  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                letterSpacing: "0.02em",
                maxWidth: isMobile ? "100%" : "700px",
                margin: "0 auto",
              }}
            >
              From founders to creatives to seekers in transition
            </p>
          </div>

          {/* Testimonials Grid - RESPONSIVE */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile
                ? "1fr"
                : isTablet
                  ? "repeat(2, 1fr)"
                  : "repeat(3, 1fr)",
              gap: isMobile ? "1.5rem" : "2.5rem",
              marginBottom: isMobile ? "3rem" : "4rem",
            }}
          >
            {/* Testimonial 1 - Ed Cottone */}
            <div
              style={{
                background: "linear-gradient(135deg, #FFFFFF 0%, #FFF5F2 100%)",
                padding: isMobile ? "2rem" : "2.5rem",
                borderRadius: isMobile ? "12px" : "16px",
                border: "2px solid #FFD6C9",
                boxShadow: "0 12px 40px rgba(227, 139, 111, 0.15)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <p
                style={{
                  fontSize: isMobile ? "0.9rem" : "1rem",
                  lineHeight: "1.75",
                  color: "#2A2A2A",
                  fontWeight: "300",
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  letterSpacing: "0.01em",
                  marginBottom: "auto",
                  flex: 1,
                }}
              >
                “For the better part of a decade, Anna has been the go-to source
                for solutions to complex esoteric problems affecting my office
                and my clients' businesses. Anna's experience and depth of
                knowledge have allowed her to quickly identify latent issues
                affecting various matters I have sought her counsel on. After
                relaying the facts to Anna, I have then marveled at how quickly
                she pivots to suggest multiple options to achieve resolution. It
                has always been time well spent to seek and obtain Anna's
                seasoned thoughts and opinions.”
              </p>
              <div
                style={{
                  borderTop: "2px solid #FFE8E0",
                  paddingTop: "1.5rem",
                  marginTop: "2rem",
                }}
              >
                <p
                  style={{
                    fontSize: isMobile ? "1rem" : "1.125rem",
                    fontWeight: "400",
                    color: "#E38B6F",
                    marginBottom: "0.25rem",
                    fontFamily: "Georgia, serif",
                  }}
                >
                  Ed Cottone, Esq.
                </p>
                <p
                  style={{
                    fontSize: isMobile ? "0.8rem" : "0.875rem",
                    color: "#C57A5C",
                    fontWeight: "400",
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  }}
                >
                  Cottone & Moon, Litigation Attorneys
                </p>
              </div>
            </div>

            {/* Testimonial 2 - Marra St. Clair */}
            <div
              style={{
                background: "linear-gradient(135deg, #FFFFFF 0%, #FFF8F6 100%)",
                padding: isMobile ? "2rem" : "2.5rem",
                borderRadius: isMobile ? "12px" : "16px",
                border: "2px solid #FFD9D4",
                boxShadow: "0 12px 40px rgba(232, 180, 174, 0.15)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <p
                style={{
                  fontSize: isMobile ? "0.9rem" : "1rem",
                  lineHeight: "1.75",
                  color: "#2A2A2A",
                  fontWeight: "300",
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  letterSpacing: "0.01em",
                  marginBottom: "auto",
                  flex: 1,
                }}
              >
                “Anna has a gift for getting to the truth fast. In a single
                session, she can illuminate the real block beneath any
                challenge. Her Clarity Sessions feel like weeks of therapy and
                strategy packed into an hour. It's impossible to put words to
                her flavor of magic, but her insights can feel like turning on
                the lights in a room I didn’t realize I was standing in the dark
                in. Her mix of intuition, strategy, and and action-orientation
                have repeatedly created immediate movement and lasting awareness
                for me.”
              </p>
              <div
                style={{
                  borderTop: "2px solid #FFEAE7",
                  paddingTop: "1.5rem",
                  marginTop: "2rem",
                }}
              >
                <p
                  style={{
                    fontSize: isMobile ? "1rem" : "1.125rem",
                    fontWeight: "400",
                    color: "#E8B4AE",
                    marginBottom: "0.25rem",
                    fontFamily: "Georgia, serif",
                  }}
                >
                  Marra St. Clair
                </p>
                <p
                  style={{
                    fontSize: isMobile ? "0.8rem" : "0.875rem",
                    color: "#D99B95",
                    fontWeight: "400",
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  }}
                >
                  Founder. Human Design Guide. Leadership Coach
                </p>
              </div>
            </div>

            {/* Testimonial 3 - Jonny Saven */}
            <div
              style={{
                background: "linear-gradient(135deg, #FFFFFF 0%, #FFF6F0 100%)",
                padding: isMobile ? "2rem" : "2.5rem",
                borderRadius: isMobile ? "12px" : "16px",
                border: "2px solid #FFDCC9",
                boxShadow: "0 12px 40px rgba(197, 122, 92, 0.15)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <p
                style={{
                  fontSize: isMobile ? "0.9rem" : "1rem",
                  lineHeight: "1.75",
                  color: "#2A2A2A",
                  fontWeight: "300",
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  letterSpacing: "0.01em",
                  marginBottom: "auto",
                  flex: 1,
                }}
              >
                “I’ve had the pleasure of working closely with Anna, and she is
                one of the most thoughtful and strategic minds I’ve ever
                encountered. Her blend of business development expertise,
                expansive network, and sharp intuition makes her an invaluable
                advisor to founders and executives alike. She brings a rare
                balance of analytical thinking and creative insight, identifying
                opportunities for growth, partnerships, and investment that
                others might overlook. Beyond her impressive experience, Anna is
                deeply intelligent, well-read, and genuinely connected to the
                people and ideas shaping modern business. Any brand or leader
                fortunate enough to work with her will benefit from her clarity,
                purpose, and visionary approach.”
              </p>
              <div
                style={{
                  borderTop: "2px solid #FFE8DB",
                  paddingTop: "1.5rem",
                  marginTop: "2rem",
                }}
              >
                <p
                  style={{
                    fontSize: isMobile ? "1rem" : "1.125rem",
                    fontWeight: "400",
                    color: "#C57A5C",
                    marginBottom: "0.25rem",
                    fontFamily: "Georgia, serif",
                  }}
                >
                  Jonny Saven
                </p>
                <p
                  style={{
                    fontSize: isMobile ? "0.8rem" : "0.875rem",
                    color: "#B8916D",
                    fontWeight: "400",
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  }}
                >
                  Chief Executive Officer, L'AGENCE
                </p>
              </div>
            </div>

            {/* Testimonial 4 - Lena Ghezel */}
            <div
              style={{
                background: "linear-gradient(135deg, #FFFFFF 0%, #FFF5F2 100%)",
                padding: isMobile ? "2rem" : "2.5rem",
                borderRadius: isMobile ? "12px" : "16px",
                border: "2px solid #FFD6C9",
                boxShadow: "0 12px 40px rgba(227, 139, 111, 0.15)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <p
                style={{
                  fontSize: isMobile ? "0.9rem" : "1rem",
                  lineHeight: "1.75",
                  color: "#2A2A2A",
                  fontWeight: "300",
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  letterSpacing: "0.01em",
                  marginBottom: "auto",
                  flex: 1,
                }}
              >
                “I’ve had the gift of knowing Anna for over fourteen years, and
                one thing has always remained constant, she leads with vision,
                grace, and deep intuition. No matter the industry, Anna doesn’t
                just meet expectations; she transcends them. She sees what
                others can’t and intuitively guides, inspires, and elevates
                everyone around her. When Anna speaks, people listen, not from
                force, but from clarity and authenticity. Her insights shift
                perspectives, open doors, and create alignment where there was
                once uncertainty. She embodies the integration of strategy and
                soul. A true leader, connector, and force of calm brilliance who
                reminds us that when we align with truth, everything flows.”
              </p>
              <div
                style={{
                  borderTop: "2px solid #FFE8E0",
                  paddingTop: "1.5rem",
                  marginTop: "2rem",
                }}
              >
                <p
                  style={{
                    fontSize: isMobile ? "1rem" : "1.125rem",
                    fontWeight: "400",
                    color: "#E38B6F",
                    marginBottom: "0.25rem",
                    fontFamily: "Georgia, serif",
                  }}
                >
                  Lena Ghezel
                </p>
                <p
                  style={{
                    fontSize: isMobile ? "0.8rem" : "0.875rem",
                    color: "#C57A5C",
                    fontWeight: "400",
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  }}
                >
                  Luxury Real Estate
                </p>
              </div>
            </div>

            {/* Testimonial 5 - Tera Stephens */}
            <div
              style={{
                background: "linear-gradient(135deg, #FFFFFF 0%, #FFF8F6 100%)",
                padding: isMobile ? "2rem" : "2.5rem",
                borderRadius: isMobile ? "12px" : "16px",
                border: "2px solid #FFD9D4",
                boxShadow: "0 12px 40px rgba(232, 180, 174, 0.15)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <p
                style={{
                  fontSize: isMobile ? "0.9rem" : "1rem",
                  lineHeight: "1.75",
                  color: "#2A2A2A",
                  fontWeight: "300",
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  letterSpacing: "0.01em",
                  marginBottom: "auto",
                  flex: 1,
                }}
              >
                “I’ve had the honor of witnessing and receiving Anna’s gifts for
                over a decade. First as a fellow entrepreneur and later as a
                dear friend. She brings light, integrity, and deep clarity to
                every interaction. Anna has helped me navigate business
                challenges with unique, actionable insights, expanding revenue,
                supporting my team, and deepening client relationships in ways I
                hadn’t imagined. Her guidance has been instrumental in growing
                both impact and profitability. Working with Anna is a true gift,
                and I will continue to recommend her to anyone seeking clarity,
                alignment, and authentic success.”
              </p>
              <div
                style={{
                  borderTop: "2px solid #FFEAE7",
                  paddingTop: "1.5rem",
                  marginTop: "2rem",
                }}
              >
                <p
                  style={{
                    fontSize: isMobile ? "1rem" : "1.125rem",
                    fontWeight: "400",
                    color: "#E8B4AE",
                    marginBottom: "0.25rem",
                    fontFamily: "Georgia, serif",
                  }}
                >
                  Tera Stephens
                </p>
                <p
                  style={{
                    fontSize: isMobile ? "0.8rem" : "0.875rem",
                    color: "#D99B95",
                    fontWeight: "400",
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  }}
                >
                  TReSs Apothecary + Salon. Owner.
                </p>
              </div>
            </div>

            {/* Testimonial 6 - Kristen P. */}
            <div
              style={{
                background: "linear-gradient(135deg, #FFFFFF 0%, #FFF6F0 100%)",
                padding: isMobile ? "2rem" : "2.5rem",
                borderRadius: isMobile ? "12px" : "16px",
                border: "2px solid #FFDCC9",
                boxShadow: "0 12px 40px rgba(197, 122, 92, 0.15)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <p
                style={{
                  fontSize: isMobile ? "0.9rem" : "1rem",
                  lineHeight: "1.75",
                  color: "#2A2A2A",
                  fontWeight: "300",
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  letterSpacing: "0.01em",
                  marginBottom: "auto",
                  flex: 1,
                }}
              >
                “I have learned so much from Anna. I admire her integrity and
                her strong work ethic. She is wise, intuitive, and passionate
                about each project she is working on. She is an excellent
                communicator and a true leader. With her many years of
                experience, she is gifted at helping others find their own life
                paths. Her ability to guide others and help them grow their own
                passions is rare to find. In my most recent guided sessions with
                Anna, I have found my inner wisdom and strength."
              </p>
              <div
                style={{
                  borderTop: "2px solid #FFE8DB",
                  paddingTop: "1.5rem",
                  marginTop: "2rem",
                }}
              >
                <p
                  style={{
                    fontSize: isMobile ? "1rem" : "1.125rem",
                    fontWeight: "400",
                    color: "#C57A5C",
                    marginBottom: "0.25rem",
                    fontFamily: "Georgia, serif",
                  }}
                >
                  Kristen P.
                </p>
                <p
                  style={{
                    fontSize: isMobile ? "0.8rem" : "0.875rem",
                    color: "#B8916D",
                    fontWeight: "400",
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  }}
                >
                  Reiki. Hypnotherapy. Author.
                </p>
              </div>
            </div>

            {/* Testimonial 7 - Jessica Rush */}
            <div
              style={{
                background: "linear-gradient(135deg, #FFFFFF 0%, #FFF5F2 100%)",
                padding: isMobile ? "2rem" : "2.5rem",
                borderRadius: isMobile ? "12px" : "16px",
                border: "2px solid #FFD6C9",
                boxShadow: "0 12px 40px rgba(227, 139, 111, 0.15)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <p
                style={{
                  fontSize: isMobile ? "0.9rem" : "1rem",
                  lineHeight: "1.75",
                  color: "#2A2A2A",
                  fontWeight: "300",
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  letterSpacing: "0.01em",
                  marginBottom: "auto",
                  flex: 1,
                }}
              >
                “Anna has an uncanny ability to see through complexity and name
                what’s real. She doesn’t sugar-coat, she brings clarity, truth,
                and perspective in a way that’s both grounded and compassionate.
                Every conversation with her leaves me more decisive and aligned
                with what actually matters. Grounded, clear, and
                unapologetically honest , Anna brings truth into focus and makes
                growth feel both possible and practical.”
              </p>
              <div
                style={{
                  borderTop: "2px solid #FFE8E0",
                  paddingTop: "1.5rem",
                  marginTop: "2rem",
                }}
              >
                <p
                  style={{
                    fontSize: isMobile ? "1rem" : "1.125rem",
                    fontWeight: "400",
                    color: "#E38B6F",
                    marginBottom: "0.25rem",
                    fontFamily: "Georgia, serif",
                  }}
                >
                  Jessica Rush
                </p>
                <p
                  style={{
                    fontSize: isMobile ? "0.8rem" : "0.875rem",
                    color: "#C57A5C",
                    fontWeight: "400",
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  }}
                >
                  Creative. Artist. Philanthropist.
                </p>
              </div>
            </div>

            {/* Testimonial 8 - Carolina C. */}
            <div
              style={{
                background: "linear-gradient(135deg, #FFFFFF 0%, #FFF8F6 100%)",
                padding: isMobile ? "2rem" : "2.5rem",
                borderRadius: isMobile ? "12px" : "16px",
                border: "2px solid #FFD9D4",
                boxShadow: "0 12px 40px rgba(232, 180, 174, 0.15)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <p
                style={{
                  fontSize: isMobile ? "0.9rem" : "1rem",
                  lineHeight: "1.75",
                  color: "#2A2A2A",
                  fontWeight: "300",
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  letterSpacing: "0.01em",
                  marginBottom: "auto",
                  flex: 1,
                }}
              >
                “Working with and knowing Anna is a deeply transformative
                experience. She blends practical insight with spiritual wisdom
                in a way that feels grounding and inspiring. Aligning people,
                brands, and opportunities with clarity and purpose is what Anna
                does best. Her years of experience across industries and her
                gift for guiding others through transition allow her to help you
                connect not only with your goals but with your deeper purpose.
                Every conversation with Anna leaves you clearer, more aligned,
                and ready for meaningful action.”
              </p>
              <div
                style={{
                  borderTop: "2px solid #FFEAE7",
                  paddingTop: "1.5rem",
                  marginTop: "2rem",
                }}
              >
                <p
                  style={{
                    fontSize: isMobile ? "1rem" : "1.125rem",
                    fontWeight: "400",
                    color: "#E8B4AE",
                    marginBottom: "0.25rem",
                    fontFamily: "Georgia, serif",
                  }}
                >
                  Carolina C.
                </p>
                <p
                  style={{
                    fontSize: isMobile ? "0.8rem" : "0.875rem",
                    color: "#D99B95",
                    fontWeight: "400",
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  }}
                >
                  Founder and Family Office Executive
                </p>
              </div>
            </div>

            {/* Testimonial 9 - Kari S. */}
            <div
              style={{
                background: "linear-gradient(135deg, #FFFFFF 0%, #FFF6F0 100%)",
                padding: isMobile ? "2rem" : "2.5rem",
                borderRadius: isMobile ? "12px" : "16px",
                border: "2px solid #FFDCC9",
                boxShadow: "0 12px 40px rgba(197, 122, 92, 0.15)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <p
                style={{
                  fontSize: isMobile ? "0.9rem" : "1rem",
                  lineHeight: "1.75",
                  color: "#2A2A2A",
                  fontWeight: "300",
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  letterSpacing: "0.01em",
                  marginBottom: "auto",
                  flex: 1,
                }}
              >
                “With her exquisite balance of intellect, emotional
                intelligence, and elegance, Anna brings a distinctive depth to
                her coaching practice and holding space. She possesses a rare
                gift for discerning the essence of any matter with acuity,
                grace, and remarkable perceptiveness. Her insight, composure,
                and intuitive brilliance bring both clarity and calm to those
                she guides.”
              </p>
              <div
                style={{
                  borderTop: "2px solid #FFE8DB",
                  paddingTop: "1.5rem",
                  marginTop: "2rem",
                }}
              >
                <p
                  style={{
                    fontSize: isMobile ? "1rem" : "1.125rem",
                    fontWeight: "400",
                    color: "#C57A5C",
                    marginBottom: "0.25rem",
                    fontFamily: "Georgia, serif",
                  }}
                >
                  Kari S., LCSW, MEd, PPSC
                </p>
                <p
                  style={{
                    fontSize: isMobile ? "0.8rem" : "0.875rem",
                    color: "#B8916D",
                    fontWeight: "400",
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  }}
                >
                  Founder Coastal Minds
                </p>
              </div>
            </div>

            {/* Testimonial 10 - Annie Clougherty */}
            <div
              style={{
                background: "linear-gradient(135deg, #FFFFFF 0%, #FFF5F2 100%)",
                padding: isMobile ? "2rem" : "2.5rem",
                borderRadius: isMobile ? "12px" : "16px",
                border: "2px solid #FFD6C9",
                boxShadow: "0 12px 40px rgba(227, 139, 111, 0.15)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <p
                style={{
                  fontSize: isMobile ? "0.9rem" : "1rem",
                  lineHeight: "1.75",
                  color: "#2A2A2A",
                  fontWeight: "300",
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  letterSpacing: "0.01em",
                  marginBottom: "auto",
                  flex: 1,
                }}
              >
                “I’ve known Anna Ackerman since she founded The R.O.A.R. Society
                before Covid, and I’ll never forget that first gathering of
                powerful women, some leading major businesses, others just
                beginning, all seeking inspiration. Even through Covid, Anna
                created purpose and connection, uniting women from every
                background. Over the years, I’ve attended her retreats and
                witnessed her impact firsthand. Anna is a true force! Driven,
                financially savvy, and one of the best connectors I’ve ever met.
                Her energy lifts everyone around her. Anyone ready to level up
                their business or themselves should work with Anna.”
              </p>
              <div
                style={{
                  borderTop: "2px solid #FFE8E0",
                  paddingTop: "1.5rem",
                  marginTop: "2rem",
                }}
              >
                <p
                  style={{
                    fontSize: isMobile ? "1rem" : "1.125rem",
                    fontWeight: "400",
                    color: "#E38B6F",
                    marginBottom: "0.25rem",
                    fontFamily: "Georgia, serif",
                  }}
                >
                  Annie Clougherty
                </p>
                <p
                  style={{
                    fontSize: isMobile ? "0.8rem" : "0.875rem",
                    color: "#C57A5C",
                    fontWeight: "400",
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  }}
                >
                  Annie Clougherty Team; Luxury Real Estate, Newport Beach, CA
                </p>
              </div>
            </div>

            {/* Testimonial 11 - Vanessa B. */}
            <div
              style={{
                background: "linear-gradient(135deg, #FFFFFF 0%, #FFF8F6 100%)",
                padding: isMobile ? "2rem" : "2.5rem",
                borderRadius: isMobile ? "12px" : "16px",
                border: "2px solid #FFD9D4",
                boxShadow: "0 12px 40px rgba(232, 180, 174, 0.15)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <p
                style={{
                  fontSize: isMobile ? "0.9rem" : "1rem",
                  lineHeight: "1.75",
                  color: "#2A2A2A",
                  fontWeight: "300",
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  letterSpacing: "0.01em",
                  marginBottom: "auto",
                  flex: 1,
                }}
              >
                “Anna has a rare gift for seeing people clearly and for holding
                space in a way that feels both grounding and transformative.
                She’s helped me find clarity through some of life’s toughest
                transitions simply through our conversations and her loving
                insight. She has an incredible ability to mirror your truth back
                to you in a way that awakens clarity and self-trust. It’s
                nothing short of magic, and I’m so excited to see her share this
                gift with the world.”
              </p>
              <div
                style={{
                  borderTop: "2px solid #FFEAE7",
                  paddingTop: "1.5rem",
                  marginTop: "2rem",
                }}
              >
                <p
                  style={{
                    fontSize: isMobile ? "1rem" : "1.125rem",
                    fontWeight: "400",
                    color: "#E8B4AE",
                    marginBottom: "0.25rem",
                    fontFamily: "Georgia, serif",
                  }}
                >
                  Vanessa B.
                </p>
                <p
                  style={{
                    fontSize: isMobile ? "0.8rem" : "0.875rem",
                    color: "#D99B95",
                    fontWeight: "400",
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  }}
                >
                  Founder. Fitness brands. Ekam Yoga and Pilates NB, CA
                </p>
              </div>
            </div>

            {/* Testimonial 12 - Jessica F. */}
            <div
              style={{
                background: "linear-gradient(135deg, #FFFFFF 0%, #FFF6F0 100%)",
                padding: isMobile ? "2rem" : "2.5rem",
                borderRadius: isMobile ? "12px" : "16px",
                border: "2px solid #FFDCC9",
                boxShadow: "0 12px 40px rgba(197, 122, 92, 0.15)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <p
                style={{
                  fontSize: isMobile ? "0.9rem" : "1rem",
                  lineHeight: "1.75",
                  color: "#2A2A2A",
                  fontWeight: "300",
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  letterSpacing: "0.01em",
                  marginBottom: "auto",
                  flex: 1,
                }}
              >
                “As an entrepreneur who has built and sold several businesses
                over the past 10 years, I’ve found Anna Ackerman to be
                invaluable. Her perspective, resources, and input have been
                instrumental across multiple areas of my work. Anna’s intuitive
                gifts help ground my decisions, ensuring they are thoughtful and
                not driven by emotion. She is a trusted advisor and confidante,
                and I deeply value her insight and support. Infinite gratitude.”
              </p>
              <div
                style={{
                  borderTop: "2px solid #FFE8DB",
                  paddingTop: "1.5rem",
                  marginTop: "2rem",
                }}
              >
                <p
                  style={{
                    fontSize: isMobile ? "1rem" : "1.125rem",
                    fontWeight: "400",
                    color: "#C57A5C",
                    marginBottom: "0.25rem",
                    fontFamily: "Georgia, serif",
                  }}
                >
                  Jessica F.
                </p>
                <p
                  style={{
                    fontSize: isMobile ? "0.8rem" : "0.875rem",
                    color: "#B8916D",
                    fontWeight: "400",
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  }}
                >
                  Serial Entrepreneur
                </p>
              </div>
            </div>
          </div>

          {/* Bottom Closing Statement - RESPONSIVE */}
          <div
            style={{
              textAlign: "center",
              marginTop: isMobile ? "3rem" : "4rem",
            }}
          >
            <p
              style={{
                fontSize: isMobile ? "1.25rem" : isTablet ? "1.75rem" : "2rem",
                lineHeight: "1.6",
                background:
                  "linear-gradient(135deg, #E38B6F 0%, #C57A5C 50%, #B8A593 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                fontWeight: "300",
                fontFamily: "Georgia, serif",
                fontStyle: "italic",
                letterSpacing: "0.02em",
              }}
            >
              When we align with truth, everything begins to flow.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section - RESPONSIVE (Landscape 8192 × 5464) */}
      <section
        id="contact"
        style={{
          position: "relative",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          overflow: "hidden",
          backgroundImage: isDesktop
            ? "url(https://firebasestorage.googleapis.com/v0/b/anna-copperfield.firebasestorage.app/o/contact-img-cr-e.jpeg?alt=media&token=3d476a6a-69a4-49ed-a118-6a30f8019605)" // Desktop landscape
            : isMobile && isLandscape
              ? "url(https://firebasestorage.googleapis.com/v0/b/anna-copperfield.firebasestorage.app/o/contact-img-cr-e.jpeg?alt=media&token=3d476a6a-69a4-49ed-a118-6a30f8019605)" // Mobile landscape (NEW)
              : "url(https://firebasestorage.googleapis.com/v0/b/anna-copperfield.firebasestorage.app/o/contact-img-cr2-e.jpeg?alt=media&token=08a94f6d-9f41-4b51-9d6c-3be30dd81f32)",
          backgroundSize: "cover",
          backgroundPosition: isMobile ? "center" : "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* Gradient Overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "linear-gradient(to bottom, rgba(42, 42, 42, 0.4) 0%, rgba(42, 42, 42, 0.9) 100%)",
            zIndex: 1,
          }}
        ></div>

        <div
          style={{
            position: "relative",
            zIndex: 2,
            textAlign: "center",
            maxWidth: isMobile ? "100%" : "900px",
            padding: isMobile ? "0 1.5rem" : "0 2rem",
            marginRight: isMobile ? "0" : isTablet ? "4rem" : "8rem",
          }}
        >
          {/* Small Label */}
          <p
            style={{
              fontSize: isMobile ? "0.55rem" : "0.625rem",
              letterSpacing: isMobile ? "0.4em" : "0.6em",
              textTransform: "uppercase",
              color: "rgba(255, 255, 255, 0.8)",
              marginBottom: isMobile ? "1.5rem" : "2rem",
              fontWeight: "600",
              fontFamily:
                '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
            }}
          >
            Let's Connect
          </p>

          {/* Main Headline - RESPONSIVE */}
          <h2
            style={{
              fontSize: isMobile ? "2rem" : "3.5rem",
              fontWeight: "300",
              fontFamily: 'Georgia, "Times New Roman", serif',
              fontStyle: "italic",
              lineHeight: "1.1",
              marginBottom: "2rem",
              color: "#fff",
              letterSpacing: "0.02em",
              textShadow: "0 4px 20px rgba(0, 0, 0, 0.4)",
            }}
          >
            <span style={{ color: "#fff" }}>Connection</span> begins
            <br />
            <span style={{ color: "#fff" }}>with conversation</span>
          </h2>

          {/* Subtext - RESPONSIVE */}
          <p
            style={{
              fontSize: isMobile ? "1rem" : isTablet ? "1.2rem" : "1.375rem",
              fontWeight: "300",
              color: "rgba(255, 255, 255, 0.95)",
              letterSpacing: isMobile ? "0.02em" : "0.05em",
              lineHeight: "1.8",
              marginBottom: isMobile ? "2rem" : "3rem",
              textShadow: "0 2px 12px rgba(0, 0, 0, 0.3)",
              fontFamily:
                '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
            }}
          >
            If something here resonates,
            <br />
            an idea, a question, or a feeling
            <br />
            then it's time for the next step!
            <br />
            I'd love to hear from you.
          </p>

          {/* Contact Button - RESPONSIVE */}
          <a
            href="mailto:annaackerman1@gmail.com"
            style={{
              display: "inline-block",
              padding: isMobile ? "1rem 2.5rem" : "1.25rem 3.5rem",
              background: "#D4A5A5",
              color: "#FFFFFF",
              fontSize: isMobile ? "0.875rem" : "1rem",
              fontWeight: "500",
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              textDecoration: "none",
              borderRadius: "50px",
              boxShadow:
                "0 8px 30px rgba(212, 165, 165, 0.4), 0 0 60px rgba(232, 180, 174, 0.2)",
              transition: "all 0.3s ease",
              fontFamily:
                '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
              border: "2px solid rgba(255, 255, 255, 0.2)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-3px)";
              e.currentTarget.style.boxShadow =
                "0 12px 40px rgba(212, 165, 165, 0.6), 0 0 80px rgba(232, 180, 174, 0.3)";
              e.currentTarget.style.background = "#E8B4AE";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 8px 30px rgba(212, 165, 165, 0.4), 0 0 60px rgba(232, 180, 174, 0.2)";
              e.currentTarget.style.background = "#D4A5A5";
            }}
          >
            Get In Touch
          </a>

          {/* Decorative Divider */}
          <div
            style={{
              width: isMobile ? "80px" : "100px",
              height: "2px",
              background:
                "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.6), transparent)",
              margin: isMobile ? "3rem auto 1.5rem" : "4rem auto 2rem",
            }}
          ></div>

          {/* Contact Info - RESPONSIVE */}
          <p
            style={{
              fontSize: isMobile ? "1rem" : "1.125rem",
              color: "rgba(255, 255, 255, 0.85)",
              fontFamily: "Georgia, serif",
              fontStyle: "italic",
              letterSpacing: "0.02em",
            }}
          >
            annaackerman1@gmail.com
          </p>
        </div>
      </section>

      {/* Footer - RESPONSIVE */}
      <footer
        style={{
          background: "linear-gradient(135deg, #FFFDF9 0%, #FFF9F3 100%)",
          padding: isMobile ? "1rem 1.5rem" : "0.75rem 2rem",
          textAlign: "center",
          fontSize: isMobile ? "0.7rem" : "0.75rem",
          fontWeight: "300",
          position: "relative",
          overflow: "hidden",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: "center",
          justifyContent: isMobile ? "center" : "space-between",
          gap: isMobile ? "0.5rem" : "0",
        }}
      >
        {/* Decorative gradient overlay */}
        <div
          style={{
            position: "absolute",
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            background:
              "radial-gradient(circle at 50% 50%, rgba(232, 180, 174, 0.15) 0%, transparent 70%)",
            pointerEvents: "none",
          }}
        ></div>

        {/* Left Spacer - Desktop only */}
        {!isMobile && (
          <div style={{ flex: 1, position: "relative", zIndex: 1 }}></div>
        )}

        {/* Center - Copyright */}
        <div style={{ position: "relative", zIndex: 1 }}>
          <p
            style={{
              color: "#5A5A5A",
              letterSpacing: "0.02em",
              margin: 0,
            }}
          >
            © {new Date().getFullYear()} Anna Ackerman. All rights reserved.
          </p>
        </div>

        {/* Right - Builder Credit */}
        <div
          style={{
            flex: isMobile ? "none" : 1,
            position: "relative",
            zIndex: 1,
            display: "flex",
            justifyContent: isMobile ? "center" : "flex-end",

          }}
        >
          <span>
            <a
              href="https://liamkande.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "rgba(90, 90, 90, 0.4)",
                textDecoration: "none",
                transition: "all 0.3s ease",
                fontSize: isMobile ? "0.75rem" : "0.8rem",
                letterSpacing: "0.05em",
                whiteSpace: "nowrap",
              }}
            >
              <img src="/liam-logo.svg" alt="Logo" width="25" height="25" />
            </a>
          </span>
        </div>
      </footer>
    </div>
  );
}

export default App;
